/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { CpOptionPaymentIpValue } from './cp-option-payment-ip-value';

/**
 *
 * @export
 * @interface CpOptionPaymentIps
 */
export class CpOptionPaymentIps {
    /**
     *
     * @type {CpOptionPaymentIpValue}
     * @memberof CpOptionPaymentIps
     */
    optionValue: CpOptionPaymentIpValue;
    /**
     *
     * @type {string}
     * @memberof CpOptionPaymentIps
     */
    _id?: string;
    /**
     *
     * @type {string}
     * @memberof CpOptionPaymentIps
     */
    optionName: CpOptionPaymentIpsOptionNameEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum CpOptionPaymentIpsOptionNameEnum {
    ClusterLbs = 'cluster_lbs',
    General = 'general',
    PaymentIps = 'payment_ips',
    PaymentIpsDeployed = 'payment_ips_deployed',
    Languages = 'languages',
    PropOptions = 'PROP_OPTIONS',
}
